import { styled, Box, Paper } from "@mui/material";

const Container = styled(Box)(({ theme }) => ({
  margin: "auto",
  display: "flex",
  flexDirection: "column",
  border: "1px solid #ddd",
  borderRadius: theme.spacing(2),
  boxShadow: 3,
  height: "92vh",
}));

const HeaderContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  borderBottom: "1px solid #ddd",
  backgroundColor: "#fafafa",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
}));

const MessageContainer = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  overflowY: "auto",
  padding: theme.spacing(2),
  backgroundColor: "#f5f5f7",
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1.5),
}));

const InputContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  padding: theme.spacing(2),
  borderTop: "1px solid #ddd",
  alignItems: "center",
  backgroundColor: "white",
}));

const MessageContent = styled(Paper)(({ theme }) => ({
  maxWidth: "75%",
  padding: theme.spacing(2),
  borderRadius: theme.spacing(1),
  whiteSpace: "normal",
  wordBreak: "break-word",
  lineHeight: 1.5,
  overflowWrap: "break-word",
}));

export {
  Container,
  HeaderContainer,
  MessageContainer,
  MessageContent,
  InputContainer,
};
